export const normalizeMultiSelectValue = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string');
  }

  if (typeof value !== 'string' || value === '') return [];

  return value.split(',');
};
